import React, { useContext, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { BASE as API_BASE, consumePostAuthRedirect } from '../services/api';
import { Button } from '../components/ui';

export default function Login() {
  const { login } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/create';

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      let target = from || '/create';
      try {
        const search = location?.search || '';
        const qp = search ? new URLSearchParams(search) : null;
        const redirectTo = qp ? qp.get('redirectTo') : null;
        const stored = consumePostAuthRedirect();
        if (redirectTo && typeof redirectTo === 'string' && redirectTo.startsWith('/')) {
          target = redirectTo;
        } else if (stored && typeof stored === 'string' && stored.startsWith('/')) {
          target = stored;
        }
      } catch {}
      navigate(target, { replace: true });
    } else {
      setError(res.error || 'Login failed');
    }
  };

  return (
    <div className="auth-panel">
      <p className="loud-eyebrow" style={{ marginBottom: 16 }}>Welcome back</p>
      <h2>Sign in</h2>
      <p className="auth-sub">Jump back in and make something loud.</p>
      <form onSubmit={onSubmit}>
        <label htmlFor="login-email">Email</label>
        <input
          id="login-email"
          name="email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
          required
        />
        <label htmlFor="login-password">Password</label>
        <input
          id="login-password"
          name="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type="password"
          required
        />
        <Button type="submit" fullWidth size="lg" loading={loading} disabled={loading}>
          {loading ? 'Signing in…' : 'Sign in'}
        </Button>
      </form>
      {error && <p className="auth-error" role="alert">{error}</p>}
      <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 10 }}>
        <Button
          type="button"
          variant="secondary"
          fullWidth
          onClick={() => {
            try {
              window.location.href = `${API_BASE}/api/auth/github/login`;
            } catch {}
          }}
        >
          Sign in with GitHub
        </Button>
        <p style={{ textAlign: 'center', margin: '8px 0 0', color: 'var(--color-text-muted)', fontSize: 14 }}>
          New here?{' '}
          <Link to="/register" style={{ fontWeight: 700 }}>
            Create a free account
          </Link>
        </p>
      </div>
    </div>
  );
}
